<script setup lang="ts">
import { ref, computed, inject } from "vue";
import { TranslationService } from "../services/translation.service";

const t = (inject<TranslationService>("translationSvc") as TranslationService)
    .t;

const { image } = defineProps({
    image: {
        type: String,
        required: true,
    },
});

const imageExpanded = ref(false);
</script>

<template>
    <div
        class="w-full relative overflow-hidden"
        :class="{
            'h-auto': imageExpanded,
            'h-[584px]': !imageExpanded,
        }"
    >
        <img :src="image" alt="Infographic" class="w-full h-auto rounded-lg" />

        <button
            @click="imageExpanded = !imageExpanded"
            class="absolute w-10 h-10 bottom-0 right-0 rounded-br-lg rounded-tl-lg bg-primary shadow-lg hover:bg-primary-light transition-colors"
        >
            <i
                class="far text-white text-f5"
                :class="imageExpanded ? 'fa-compress-alt' : 'fa-expand-alt'"
            ></i>
        </button>
    </div>
</template>
